import { createSlice } from "@reduxjs/toolkit";

const materialSlice = createSlice({
    name: 'material',
    initialState: {
        materiais: [],
        materialIndividual: {},
        materialTabelaPadrao: []
    },
    reducers: {
        addMaterialTabelaPadrao: (state, action) => {
            state.materialTabelaPadrao = action.payload
        },
        addMaterial: (state, action) => {
            state.materiais = action.payload
        },
        addMaterialIndividual: (state, action) => {
            state.materialIndividual = action.payload
        },
    },
});

export const { addMaterialTabelaPadrao, addMaterial, addMaterialIndividual } = materialSlice.actions;
export default materialSlice.reducer;